// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../Utils/baseQueryWithReauth";
import { FeatureRestrictionConfig } from "../interfaces/FeatureRestrictionConfig.interfaces";
import { TopCustomerProps, TopProductProps, TopReportProps } from "../pages/HomePage";

// Define a service using a base URL and expected endpoints
export const homeApi = createApi({
  reducerPath: "home",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    GetHomePageData: builder.query({
      query: () => "home/getHomePageData"
    }),
    GetRecentlyViewedItems: builder.query<
      {
        recentlyViewedCustomers: TopCustomerProps[];
        recentlyViewedProducts: TopProductProps[];
        recentlyViewedReports: TopReportProps[];
      },
      { loginEmail: string; loginName: string }
    >({
      query: ({ loginEmail, loginName }) => ({
        url: `common/getRecentlyViewedItems?LoginEmail=${loginEmail}&LoginName=${loginName}`
      })
    }),
    GetUIEnablementsSettings: builder.query<FeatureRestrictionConfig[], undefined>({
      query: () => "home/getUIEnablementsSettings"
    })
  })
});

export const {
  useGetHomePageDataQuery,
  useGetRecentlyViewedItemsQuery,
  useGetUIEnablementsSettingsQuery,
  useLazyGetUIEnablementsSettingsQuery
} = homeApi;
